let root = "https://admin.texexcellance.com/";
// if (process.env.NODE_ENV === "production") {
//   root = process.env.NEXT_PUBLIC_ROOT_URL;
// } else {
//   root = "http://localhost:8080/";
//   // root = process.env.NEXT_PUBLIC_ROOT_URL;
// }

const urls = {
  root: root,
  api: `${root}api/`,
  image: `${root}website/`,
  upload: `${root}`,

  setting: `${root}api/settings`,
  menu: `${root}api/menu-group/active/menu-item/website`,
  banner: `${root}api/banner/active`,
  about: `${root}api/about-us`,
  messageFromManagement: `${root}api/messageManagement/active`,
  footer: `${root}api/footer`,
  service: `${root}api/service/active`,
  productCategory: `${root}api/product-category`,
  product: `${root}api/product/active`,
  productCategoryOne: `${root}api/product-category/active`, // getBySlug
  productOne: `${root}api/product`,
  brand: `${root}api/brand/active`,
  corporateLogo: `${root}api/corporate-logo/active`,
  partnersLogo: `${root}api/partners-logo/active`,
  album: `${root}api/album/active/media-gallery`,
  albumOne: `${root}api/album/active/media-gallery`,
  gallery: `${root}api/media-gallery/get-data/active?group=photo_gallery`,
  blog: `${root}api/blogs/active`,
  blogDetail: `${root}api/blogs/`,
  why_choose_us: `${root}api/why_choose_us/active`,
  testimonial: `${root}api/testimonial/active`,
  stats: `${root}api/stats/active`,
  workingProcess: `${root}api/working-process/active`,

  contact: `${root}api/contact-message`,
  subscribe: `${root}api/newsletterSubscription`,
};

export default urls;
